import { render, staticRenderFns } from "./EditUserProfileDialog.vue?vue&type=template&id=0b42e719&scoped=true"
import script from "./EditUserProfileDialog.vue?vue&type=script&lang=js"
export * from "./EditUserProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./EditUserProfileDialog.vue?vue&type=style&index=0&id=0b42e719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b42e719",
  null
  
)

export default component.exports